import { message } from 'antd'
import { replace } from 'connected-react-router'
import intl from 'utils/intl'
import messages from 'languages/messages'

export default function resultHandle(result, success, dispatch, error, errControl) {
  const body = result.body || {}
  const msg =
    (result.head && `${result.head.msg}`) ||
    intl().formatMessage(messages['app.error.system'])
  const traceCode = result.head.traceCode
  // APIs may return numeric or string codes (e.g. 200 vs "200")
  const code = result.head.code != null && result.head.code !== '' ? String(result.head.code) : ''
  switch (code) {
    case '200':
      success(Object.assign(body, { request: 'success' }))
      return Object.assign(body, { request: 'success', isFetching: false })
    case '406':
      // Handle "Install plan empty!" as no plans available (not an error)
      if (result.head.msg && result.head.msg.includes('Install plan empty')) {
        success(Object.assign({}, { request: 'success' }))
        break
      }
      // Fall through to default for other 406 errors
    case '60012':
    case '60013':
      dispatch(
        replace(
          `/error?code=${result.head.code}&msg=${msg}&traceCode=${traceCode}`
        )
      )
      break
    default: {
      if (typeof error === 'function') {
        error(result, `${msg}[${traceCode}]`)
      } else if (errControl) {
        dispatch(
          replace(
            `/error?code=${result.head.code}&msg=${msg}&traceCode=${traceCode}`
          )
        )
      } else {
        message.error(`${msg}[${traceCode}]`, 5)
      }
      break
    }
  }
  return Object.assign(body, {
    isFetching: false,
  })
}
